export default {
  localization: {
    defaultLocale: 'en',
  },
  header: {
    fixed: true,
    offset: 88,
    offsetMobile: 60,
  },
}
